import * as types from "../actions/actionType";
import initialState from "./initialState";

const formReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.SET_DATA:
        return {
          ...state,
          data: action.payload
        }
      case types.SET_LANDLORD_ARRAY:
        return {
          ...state,
          landlordArray: action.payload
        }
    case types.SET_APARTMENT_ARRAY:
        return {
          ...state,
          apartmentArray: action.payload
        }
    case types.SET_RIDER_ARRAY:
        return {
          ...state,
          policyArray: action.payload
        }
    case types.SET_CLAIMID:
      return {
        ...state,
        claimId: action.payload
      }
    case types.SET_ERR:
      return {
        ...state,
        error: action.payload
      }
    case types.SET_POLICY_DUPLICATED:
      return {
        ...state,
        policyDuplicated: action.payload
      }
    case types.SET_RESULT: 
      return {
        ...state,
        result: action.payload
      }
    case types.SET_INITIATE:
      return {
        ...initialState,
        landlordArray: state.landlordArray
      }
    default:
      return state;
  }
};

export default formReducer;
